export class Category {
  id: number;
  count: number;
  title: string;
  description: string;
  imageFileId: string;
  keyword: string;

  static readonly descriptions: { [key: string]: string } = {
    '3':
      'იდეები ქალაქში არსებული საგზაო ინფრასტრუქტურის მართვა-განვითარებასა და აღდგენა-შეკეთებასთან დაკავშირებით',
    '4':
      'საქალაქო რეგულარულ სამგზავრო გადაყვანის, ტრანსპორტის მოძრაობის ორგანიზებისა და სატრანსპორტო საშუალებების პარკირებასთან დაკავშირებული იდეები',
    '5':
      'იდეები, რომლებიც ეხება ქალაქის დასუფთავებისა და ნარჩენების მართვის საკითხს',
    '6':
      'იდეები, რომლებიც შეეხება ქალაქის ტერიტორიაზე არსებული სანიაღვრე ქსელებისა და კოლექტორების, წყალმომარაგების სისტემის მოვლა-პატრონობასა და მართვას',
    '7':
      'თბილისის ქუჩების, სკვერებისა და საზოგადოებრივი ადგილების განათებასთან დაკავშირებული იდეები',
    '8':
      'იდეები, რომლებიც ეხება თბილისის ტერიტორიაზე არსებული მწვანე საფარის (ბაღები, სკვერები, ქუჩის გამწვანება) მოწყობას, აღდგენასა და შეკეთებას',
    '9':
      'იდეები, რომლებიც ემსახურება განათლების დონის ამაღლებასა და ხელმისაწვდომობის უზრუნველყოფას',
    '10':
      'შშმ პირების საზოგადოებაში ინტეგრაციის ხელშეწყობასთან და მათთვის შესაბამისი ინფრასტრუქტურის მოწყობასთან დაკავშირებული იდეები',
    '11':
      'ქალაქ თბილისში განათლების, სპორტისა და ახალგაზრდულ საქმეთა დარგების მართვა-განვითარებასთან დაკავშირებული იდეები',
    '12':
      'იდეები, რომლებიც შეეხება თბილისის მოსახლეობის ჯანმრთელობის დაცვისა და სოციალური უზრუნველყოფის თემებს',
    '13':
      'იდეები, რომლებიც უკავშირდება ქალაქ თბილისის მოსახელობისათვის კომფორტული, უსაფრთხო და ჯანსაღი საცხოვრებელი და სამოღვაწეო გარემოს შექმნას',
    '14':
      'ქალაქ თბილისის მერიის ზოგადი საქმიანობისა და ბიუჯეტის ხარჯვის გამჭვირვალობასთან, მოქალაქეთა ჩართულობასთან და ინფორმაციულ ხელმისაწვდომობასთან დაკავშირებული იდეები',
    '21':
      'იდეები, რომელთა განხილვა განეკუთვნება მერიის კომპეტენციას და არ მოიაზრება რომელიმე სხვა უკვე არსებულ კატეგორიაში',
    '22':
      'თბილისის მდგრადი ეკონომიკური განვითარებისთვის ხელსაყრელი გარემო პირობების შექმნასთან დაკავშირებული იდეები'
  };
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/shared/category.ts